import { Component, ViewChild, inject } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'src/app/auth/auth.service';
import { SettlementBonusKinds, SettlementTerms } from '../settlement.model';
import { Permissions } from '@/common/enums/Permissions';

@Component({
	selector: 'app-settlement-bonus',
	templateUrl: './settlement-bonus.component.html',
	styleUrls: ['./settlement-bonus.component.css'],
})
export class SettlementBonusComponent extends ShowComponent {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild('dataTableFiles') tableFiles: MatTable<any>;
	settlementBonusName: Array<any> = [];
	editable: boolean;
	drivers: Array<any> = [];
	users: Array<any> = [];
	vehicles: Array<any> = [];
	currency: Array<any> = [];
	terms: Array<any> = [];
	settlementBonusHistory: Array<any> = [];
	itemToRemove;
	labelValue = 0;
	driverSalaryConfirmed = false;
	LoaderService = false;
	url = '';
	matData = new MatTableDataSource<any>();

	displayedColumns: string[] = ['lp', 'month', 'value', 'currency', 'comment', 'toDelete'];
	displayedColumns2: string[] = ['url', 'download', 'toDelete'];
	historyBonusTable: string[] = ['editBy', 'editAt', 'detail'];
	termRange = {
		start: null,
		end: null,
	};
	data = {
		id: null,
		ownerId: null,
		name: null,
		value: null,
		isSettled: null,
		comment: null,
		date: null,
		settlementBonusNameId: null,
		terms: [],
		files: [],
		vehicleId: null,
		confirmAt: null,
		confirmBy: null,
		confirmPerson: null,
		user: null,
		confirm: null,
		confirmButton: null,
		workshop: null,
		workshopButton: null,
		valueCurrencyId: 1,
		settlementCurrencyId: 1,
		workshopBy: null,
		workshopAt: null,
		workshopComment: null,
		eventId: null,
	};

	readonly Permissions = Permissions;

	readonly auth = inject(AuthService);

	protected readonly SettlementBonusKinds = SettlementBonusKinds;
	protected idType = 'auto';
	protected itemsBeforeDataLoad = 6;
	protected parentComponent = 'settlements/settlementBonus';
	protected apiUrl = '/settlements/SettlementBonus/';
	protected apiUrlAdd = '/settlements/SettlementBonus/';

	protected loadBefore() {
		this.bag.get('/currency/?limit=50', (result, error) => {
			this.currency = result.results;
			this.loadData();
		});
		this.api.get('/settlements/settlementBonusName/', (result) => {
			this.settlementBonusName = result.data;
			this.loadData();
		});
		this.api.get('/drivers/', (result) => {
			this.drivers = result.data;
			this.loadData();
		});
		this.api.get('/vehicles/', (result) => {
			this.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result) => {
			this.users = result.data;
			this.loadData();
		});
		this.api.get('/settlements/settlementBonusHistory/?positionId=' + this.data.id, (result) => {
			this.settlementBonusHistory = result.data;
			this.loadData();
		});
		if (this.pageFunction == 'add') {
			this.addPos();
		}
	}

	protected clearTerm() {
		if (this.pageFunction === 'add' && this.data.settlementBonusNameId === '1') {
			this.data.terms = [];
		} else {
			this.data.terms = [];
			this.addPos();
		}
	}

	addPos() {
		const terms = {
			id: null,
			comment: null,
			value: 0,
			month: null,
			isSettled: null,
			calculateToCash: null,
		};
		if (this.pageFunction == 'add') {
			terms.month = this.date.now().date;
		}
		this.data.terms.push(terms);
		this.table.renderRows();
	}

	checkSettlementKind() {
		if (!this.data.settlementBonusNameId) {
			return;
		}
		const settlementKind = this.settlementBonusName.find(
			(objFind) => objFind.id === this.data.settlementBonusNameId,
		);
		if (this.data.value < 0 && settlementKind.negative === '0') {
			return (this.data.value = this.data.value * -1);
		}
		if (this.data.value > 0 && settlementKind.negative === '1') {
			if (!this.data.value) {
				return (this.data.value = null);
			}
			return (this.data.value = Math.abs(this.data.value) * -1);
		}
	}

	generateTerms() {
		const date = new Date(this.termRange.start.getTime());
		while (date <= this.termRange.end) {
			const terms = {
				id: null,
				comment: null,
				value: 0,
				month: null,
				isSettled: null,
				calculateToCash: null,
				currency: '',
			};
			terms.month = this.date.daysAdd(0, new Date(date));
			date.setDate(date.getDate() + 1);
			this.data.terms.push(terms);
		}
		this.table.renderRows();
	}

	clearValue(): void {
		this.clearTerm();
		return (this.data.value = null);
	}

	deleteTerm(element: SettlementTerms): void {
		element.toDelete = !element.toDelete;
	}

	save(): void {
		const foundCurrency = this.currency.find((c) => c.id === this.data.valueCurrencyId);
		if (foundCurrency) {
			this.data.terms.forEach((term) => {
				term.currency = foundCurrency.code;
			});
		}
		this.submit();
	}

	protected afterSend(result, error) {
		this.loader.hide();
		if (error) {
			return;
		}
		this.data.terms = result.data.terms;
		this.router.navigate([this.parentComponent, this.data.id]);
		this.pageFunction = 'edit';
		this.editable = false;
		this.infobox.success('Zapisano');
		this.pageTitle = this.pageTitleGenerate();
		this.apiUrl = this.getApiUrl();
		this.submitAfter();
	}

	checkConfirmSalaryDrivers() {
		this.driverSalaryConfirmed = false;
		const driver = {
			driver: this.data?.ownerId,
			terms: this.data.terms.filter((obj) => obj.isSettled == 0 || !obj.isSettled),
		};
		let confirmedCollision;
		this.api.command(
			'/tourismEvents/',
			{ cmd: 'checkIfSettlementDriverConfirmed', get: driver },
			(result, error) => {
				if (error) {
					return;
				}
				confirmedCollision = result.data;
				if (confirmedCollision.length != 0) {
					this.driverSalaryConfirmed = true;
					this.infobox.error('Ten kierowca ma zatwierdzone rozliczenie');
					return;
				}
				this.save();
			},
		);
	}

	protected convertData(data) {
		this.labelValue = 0;
		data.terms.forEach((obj) => {
			this.labelValue += parseFloat(obj.value);
		});
		data.settlementCurrencyId = parseInt(data.settlementCurrencyId);
		data.valueCurrencyId = parseInt(data.valueCurrencyId);
		if (!data.confirmAt || !data.confirmAt.length) {
			data.confirmButton = false;
			data.confirm = 'nie zatwierdzono';
		} else {
			data.confirmButton = true;
			data.confirm = data.confirm?.user + ' ' + this.date.formatIsoToLocal(data.confirmAt);
		}
		if (!data.workshopAt || !data.workshopAt.length) {
			data.workshopButton = false;
			data.workshop = 'nie zatwierdzono';
		} else {
			data.workshopButton = true;
			data.workshop = data.workshop.user + ' ' + this.date.formatIsoToLocal(data.workshopAt);
		}
		return data;
	}

	afterLoadData() {
		if (this.pageFunction == 'add') {
			this.data.date = this.date.now().date;
		}
	}

	calculateValue(data) {
		this.labelValue = 0;
		if (!this.data.settlementBonusNameId) {
			return;
		}
		const settlementKind = this.settlementBonusName.find(
			(objFind) => objFind.id === this.data.settlementBonusNameId,
		);
		data.terms.forEach((obj) => {
			this.labelValue += parseFloat(obj.value);
			if (obj.value < 0 && settlementKind.negative === '0') {
				obj.value = obj.value * -1;
			}
			if (settlementKind.negative === '1') {
				obj.value = Math.abs(obj.value) * -1;
			}
		});
		this.labelValue = Math.round(this.labelValue * 100) / 100;
		return data;
	}

	uploadFile(event) {
		this.bag.upload('/multimedia/file/', event.target.files[0], (result, error) => {
			this.url = result.url;
			this.data.files.push({
				id: null,
				fileID: result.id,
				name: null,
				url: result.url,
			});
			this.tableFiles.renderRows();
		});
	}

	deleteFile(element) {
		element.toDelete = !element.toDelete;
	}

	protected confirm(type: string) {
		const month = this.data.date.slice(0, -3);
		this.api.get(
			'/driver/driverSummaryList/?driver=' + this.data.ownerId + '&settlementMonth=' + month + '&version=1',
			(result) => {
				if (result.data.length > 0 && result.data) {
					this.infobox.error(
						'Nie można wykonać akcji odtwierdź dodatku/potrącenia, kierowca ma zatwierdzone wynagrodzenie za bieżący miesiąc',
					);
					return;
				}
				let user;
				this.api.get('/users/?id=' + this.auth.getUserId(), (result) => {
					user = result.data[0];
					switch (type) {
						case 'confirmBonus':
							this.confirmBonus(user);
							break;
						case 'confirmWorkshop':
							this.confirmWorkshop(user);
							break;
					}
				});
			},
		);
	}

	confirmBonus(user: any) {
		this.data.confirmButton = !this.data.confirmButton;
		if (this.data.confirmButton == true) {
			this.data.confirmBy = this.auth.getUserId();
			this.data.confirmAt = this.date.toUtcIso(new Date());
			this.data.confirm =
				user.firstName + ' ' + user.lastName + ' ' + this.date.formatIsoToLocal(this.data.confirmAt);
		} else {
			this.data.confirmAt = null;
			this.data.confirmBy = null;
			this.data.confirm = null;
		}
		this.api.command(
			`/settlements/settlementBonus`,
			{ cmd: 'confirm', id: this.data.id, action: this.data.confirmButton },
			(result, error) => {
				if (error) {
					this.infobox.error(error.error.error);
					return;
				}
				const messageText = this.data.confirmButton
					? 'Zatwierdzono dodatki.'
					: 'Anulowano zatwierdzenie dodatków.';
				this.infobox.success(messageText);
			},
		);
	}

	confirmWorkshop(user) {
		this.data.workshopButton = !this.data.workshopButton;
		if (this.data.workshopButton == true) {
			this.data.workshopBy = this.auth.getUserId();
			this.data.workshopAt = this.date.toUtcIso(new Date());
			this.data.workshop =
				user.firstName + ' ' + user.lastName + ' ' + this.date.formatIsoToLocal(this.data.workshopAt);
		} else {
			this.data.workshopAt = null;
			this.data.workshopBy = null;
			this.data.workshop = null;
		}
		this.save();
	}
}
